import palette from 'lib/styles/palette';
import { toast } from 'react-hot-toast';
import { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';
import { authEmail } from 'lib/api/auth';
import { useSelector } from 'react-redux';
import client, { serviceClient } from 'lib/api/client';
import { useEffect } from 'react';

const EmailAuthPage = () => {
  const navigate = useNavigate();
  const {
    accessToken,
    refreshToken,
    userLevel,
    userType,
    userId,
    username,
    email,
    changePassword,
    allowPersonalinfo,
  } = useSelector(({ auth }) => auth);
  const [authNumber, setAuthNumber] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const authEmailMutation = useMutation(authEmail, {
    onSuccess: data => {
      toast.success('인증 메일이 성공적으로 전송되었습니다!');
      setCode(data.data.code);
      setError('');
    },
    onError: error => {
      setError(error.response.data.msg);
    },
  });

  const sendMail = () => {
    authEmailMutation.mutate({ email, id: userId });
  };

  const onSubmit = () => {
    if (code === authNumber) {
      toast.success('인증이 성공했습니다!');

      client.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
      serviceClient.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${accessToken}`;

      if (changePassword) {
        navigate(`/reset/${userId}/${userLevel}/${userType}`);
        return;
      }

      if (allowPersonalinfo === 0) {
        navigate(`/privacy-policy`);
        return;
      }

      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('username', username);
      localStorage.setItem('userLevel', userLevel);
      localStorage.setItem('userType', userType);
      localStorage.setItem('userId', userId);

      navigate('/admin');
    } else {
      setError('인증번호가 틀렸습니다');
    }
  };

  useEffect(() => {
    if (!userId) {
      navigate('/');
    }
  }, [userId, navigate]);

  return (
    <Container>
      <Box>
        <div className="logo">2차 인증</div>
        <div className="wrapepr">
          <StyledButton style={{ width: 240 }} onClick={sendMail}>
            인증 메일 전송
          </StyledButton>
        </div>

        <StyledInput
          style={{ marginTop: 20, width: 240 }}
          placeholder="인증번호"
          value={authNumber}
          onChange={e => setAuthNumber(e.target.value)}
        />
        {error && <div className="error">{error}</div>}
        <ButtonWrapper>
          <StyledButton
            style={{ backgroundColor: palette.theme[0] }}
            onClick={() => navigate('/')}
          >
            취소
          </StyledButton>
          <StyledButton disabled={!authNumber} onClick={onSubmit}>
            확인
          </StyledButton>
        </ButtonWrapper>
      </Box>
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${palette.background};
`;

const Box = styled.div`
  width: 500px;
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: solid 1px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.04);

  .logo {
    font-size: 1.5rem;
    color: ${palette.theme[3]};
    font-weight: 600;
    letter-spacing: 5px;
    margin-bottom: 30px;
  }

  .error {
    margin-top: 20px;
    color: red;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 30px;
`;

const StyledButton = styled.button`
  border: none;
  background-color: ${palette.theme[3]};
  color: #fff;
  padding: 15px 30px;
  border-radius: 11px;
  font-size: 16px;
  cursor: pointer;
  & + & {
    margin-left: 10px;
  }
  &:disabled {
    background-color: ${palette.theme[0]};
  }
`;

const StyledInput = styled.input`
  height: 50px;
  padding: 15px;
  border: solid 1px #dfdfdf;
  border-radius: 11px;
  background: #fff;
  font-size: 16px;
  &::placeholder {
    color: #c6c6c6;
  }
  margin-right: 10px;
`;

export default EmailAuthPage;
